var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.device],attrs:{"id":"app"}},[(_vm.device == 'pc')?_c('PcHeader'):_c('MobileHeader'),_c('div',{staticClass:"page"},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),(_vm.device == 'pc')?_c('PcFooter'):_c('MobileFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }